import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';

type DueDate = {
  dayOfMonth: number;
  month: number;
  timeZone: number;
  year: number;
};

type Invite = {
  email?: string;
  firstName?: string;
  groups?: string[];
  lastName?: string;
  name?: string;
  roles?: string[];
  selected?: boolean;
  toBeInvited?: boolean;
};

type TaskListId = { taskListId: { id: string } };
type WorkflowId = { workflowId: { id: string } };

export const assignTraining = (
  trainingId: string,
  isWorkflow: boolean,
  assigneeIds: string[],
  orgId: string,
  initiatingUserId: string,
  sendEmail: boolean,
  invite: Invite | null,
  dueDate?: DueDate
) => {
  cacheService.remove(`/v1/cpca-assignments`);
  cacheService.remove(`/v1/organizations/${orgId}/assignments`);
  cacheService.removeAllInPath(`/v1/assignments/users`);
  cacheService.removeAllInPath(`/v1/trainingOverview`);

  const id = uuid.generate();

  const trainingIdPayload: TaskListId | WorkflowId = isWorkflow
    ? { workflowId: { id: trainingId } }
    : { taskListId: { id: trainingId } };

  const cmd = {
    id,
    assigneeIds,
    initiatingUserId,
    orgId: { id: orgId },
    sendEmail,
    invite,
    training: {
      id: trainingIdPayload,
      entityOptions: {},
      ...(dueDate && { dueDate }),
    },
  };

  return submitCommand(id, cmd, 'AssignTraining', 'AssignSucceeded', 'TrainingassignedError');
};
